import React, { PropsWithChildren, useRef } from 'react'
import { Provider } from 'react-redux'
import { useCoreAdapters } from '@liefersoft/pos-ui-core'
import { makeStore } from './configureStore'
import type { AppStore, RootState } from './types'

type StoreProviderProps = PropsWithChildren<{ preloadedState?: unknown }>

const StoreProvider = ({ children, preloadedState }: StoreProviderProps) => {
	const storeRef = useRef<AppStore | null>(null)
	const { internalApi, logger } = useCoreAdapters()

	if (!storeRef.current) {
		storeRef.current = makeStore({ internalApi, logger }, preloadedState as Partial<RootState>)
	}

	return <Provider store={storeRef.current}>{children}</Provider>
}

StoreProvider.displayName = 'StoreProvider'

export default StoreProvider
